import React from "react";
import * as Sentry from "@sentry/react";

export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    Sentry.captureException(error, { contexts: { react: { componentStack: info.componentStack } } });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    // Do not expose raw error messages to end-users in production.
    // The full error is available in the browser console for developers.
    const isDev = process.env.NODE_ENV === "development";
    const msg = isDev
      ? (this.state.error?.message ?? String(this.state.error))
      : "An unexpected error occurred. Please reload the app.";

    return (
      <div style={{
        minHeight: "100vh", background: "#060a0f",
        display: "flex", alignItems: "center", justifyContent: "center",
        fontFamily: "'IBM Plex Mono', 'Courier New', monospace",
      }}>
        <div style={{
          background: "#080c12", border: "1px solid #ff6b3544",
          borderLeft: "4px solid #ff6b35",
          borderRadius: 8, padding: "40px 48px", maxWidth: 600, width: "100%",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
            <div style={{ width: 8, height: 8, background: "#ff6b35", borderRadius: "50%", boxShadow: "0 0 8px #ff6b35" }} />
            <span style={{ color: "#ff6b35", fontWeight: 700, letterSpacing: "0.1em", fontSize: 13 }}>NUVPORT OS — SYSTEM ERROR</span>
          </div>

          <div style={{ color: "#c9d1d9", fontSize: 15, fontWeight: 600, marginBottom: 12 }}>
            A rendering error crashed the application.
          </div>

          <div style={{
            background: "#0d1117", border: "1px solid #1c2333",
            borderRadius: 6, padding: "12px 16px", marginBottom: 24,
            color: "#ff6b35", fontSize: 12, wordBreak: "break-word", lineHeight: 1.6,
          }}>
            {msg}
          </div>

          <div style={{ display: "flex", gap: 12 }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: "#3ddc8418", border: "1px solid #3ddc8444",
                color: "#3ddc84", borderRadius: 6, padding: "10px 24px",
                cursor: "pointer", fontSize: 12, letterSpacing: "0.08em",
                fontFamily: "inherit",
              }}
            >↺ RELOAD APP</button>
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              style={{
                background: "none", border: "1px solid #1c2333",
                color: "#8b949e", borderRadius: 6, padding: "10px 24px",
                cursor: "pointer", fontSize: 12, letterSpacing: "0.08em",
                fontFamily: "inherit",
              }}
            >TRY RECOVER</button>
          </div>

          <p style={{ color: "#8b949e33", fontSize: 10, marginTop: 20 }}>
            Check browser console for full stack trace · Your portfolio data is safe in localStorage
          </p>
        </div>
      </div>
    );
  }
}
